export var minutesToSeconds = function minutesToSeconds(minutes) {
  return 60 * minutes;
};
export var hoursToSeconds = function hoursToSeconds(hours) {
  return minutesToSeconds(60) * hours;
};
export var daysToSeconds = function daysToSeconds(days) {
  return hoursToSeconds(24) * days;
};
export var secondsToMinutes = function secondsToMinutes(seconds) {
  return seconds / 60;
};
export var secondsToHours = function secondsToHours(seconds) {
  return secondsToMinutes(seconds) / 60;
};
export var secondsToDays = function secondsToDays(seconds) {
  return secondsToHours(seconds) / 24;
};
export var secondsToMonths = function secondsToMonths(seconds) {
  return secondsToDays(seconds) / 31;
};
export var monthsToSeconds = function monthsToSeconds(months) {
  return daysToSeconds(31) * months;
};